import { render, staticRenderFns } from "./GetUserGroups.vue?vue&type=template&id=26f084a0&"
import script from "./GetUserGroups.vue?vue&type=script&lang=js&"
export * from "./GetUserGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports